import {marked}from'marked';import {gfmHeadingId}from'marked-gfm-heading-id';import f from'highlight.js';import x from'isomorphic-dompurify';function u(e){return e.toLowerCase().trim().replace(/[^\w\s-]/g,"").replace(/\s+/g,"-").replace(/-+/g,"-").replace(/^-+|-+$/g,"")}function c(e){let r=new DOMParser().parseFromString(e,"text/html").querySelectorAll("h1, h2, h3, h4, h5, h6"),i=[],h=[];return r.forEach(a=>{let m=parseInt(a.tagName[1]),l=a.textContent||"",s=a.id||u(l);a.id||(a.id=s);let n={text:l,level:m,id:s};for(;h.length>0&&h[h.length-1].level>=m;)h.pop();if(h.length===0)i.push(n);else {let g=h[h.length-1].item;g.children||(g.children=[]),g.children.push(n);}h.push({item:n,level:m});}),i}function p(e,t,o){return `<div class="${["markdown-viewer",`theme-${t}`,o].filter(Boolean).join(" ")}">${e}</div>`}marked.use({gfm:true,breaks:true});marked.use(gfmHeadingId());var M={code(e,t){if(t==="mermaid")return `<pre><code class="language-mermaid">${e.replace(/</g,"&lt;").replace(/>/g,"&gt;")}</code></pre>`;if(t&&f.getLanguage(t))try{let i=f.highlight(e,{language:t}).value;return `<pre><code class="hljs language-${t}">${i}</code></pre>`}catch(i){console.warn("Syntax highlighting failed:",i);}let o=e.replace(/</g,"&lt;").replace(/>/g,"&gt;");return `<pre><code${t?` class="language-${t}"`:""}>${o}</code></pre>`},listitem(e,t){if(t){let o=e.startsWith("<input checked"),r=e.replace(/<input[^>]*>/i,"");return `<li class="task-list-item">
        <input type="checkbox" ${o?"checked":""} disabled />
        ${r}
      </li>`}return `<li>${e}</li>`}};marked.use({renderer:M});function k(e){return /```mermaid[\s\S]*?```/.test(e)}function v(e){return /\$\$[\s\S]+?\$\$|\$[^\$\n]+?\$/.test(e)}function w(e){return e.replace(/<pre><code class="(?:hljs )?language-mermaid">([\s\S]*?)<\/code><\/pre>/g,(t,o)=>`<div class="mermaid">${o.replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&quot;/g,'"').replace(/&#39;/g,"'").replace(/&amp;/g,"&")}</div>`)}async function z(e){let t=await import('katex');return e=e.replace(/\$\$([\s\S]+?)\$\$/g,(o,r)=>{try{return t.default.renderToString(r,{displayMode:!0,throwOnError:!1})}catch(i){return console.warn("KaTeX rendering failed:",i),`<span class="math-error">$$${r}$$</span>`}}),e=e.replace(/\$([^\$\n]+?)\$/g,(o,r)=>{try{return t.default.renderToString(r,{displayMode:!1,throwOnError:!1})}catch(i){return console.warn("KaTeX rendering failed:",i),`<span class="math-error">$${r}$</span>`}}),e}async function S(e,t={}){let{theme:o="github-light",enableMermaid:r=true,enableMath:i=true,sanitize:h=true,className:a,generateTOC:m=false}=t,l=r&&k(e),s=i&&v(e),n=await marked.parse(e);l&&(n=w(n)),s&&(n=await z(n)),h&&(n=x.sanitize(n,{ADD_TAGS:["input"],ADD_ATTR:["checked","disabled","type"]}));let g;return m&&(g=c(n)),n=p(n,o,a),{html:n,toc:g,hasMermaid:l,hasMath:s}}function R(e,t={}){let{theme:o="github-light",enableMermaid:r=true,sanitize:i=true,className:h}=t,a=marked.parse(e);return r&&k(e)&&(a=w(a)),i&&(a=x.sanitize(a,{ADD_TAGS:["input"],ADD_ATTR:["checked","disabled","type"]})),p(a,o,h)}var y=`
/* GitHub Light Theme */
.markdown-viewer.theme-github-light {
  color: #1f2328;
  background-color: #ffffff;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Noto Sans", Helvetica, Arial, sans-serif;
  font-size: 16px;
  line-height: 1.6;
  word-wrap: break-word;
}

.theme-github-light h1,
.theme-github-light h2 {
  border-bottom: 1px solid #d1d9e0;
  padding-bottom: 0.3em;
}

.theme-github-light h1 { font-size: 2em; margin-top: 24px; margin-bottom: 16px; font-weight: 600; }
.theme-github-light h2 { font-size: 1.5em; margin-top: 24px; margin-bottom: 16px; font-weight: 600; }
.theme-github-light h3 { font-size: 1.25em; margin-top: 24px; margin-bottom: 16px; font-weight: 600; }
.theme-github-light h4 { font-size: 1em; margin-top: 24px; margin-bottom: 16px; font-weight: 600; }
.theme-github-light h5 { font-size: 0.875em; margin-top: 24px; margin-bottom: 16px; font-weight: 600; }
.theme-github-light h6 { font-size: 0.85em; margin-top: 24px; margin-bottom: 16px; font-weight: 600; color: #59636e; }

.theme-github-light p { margin-top: 0; margin-bottom: 16px; }
.theme-github-light blockquote {
  margin: 0 0 16px 0;
  padding: 0 1em;
  color: #59636e;
  border-left: 0.25em solid #d1d9e0;
}

.theme-github-light ul, .theme-github-light ol {
  margin-top: 0;
  margin-bottom: 16px;
  padding-left: 2em;
}

.theme-github-light li + li { margin-top: 0.25em; }

.theme-github-light code {
  padding: 0.2em 0.4em;
  margin: 0;
  font-size: 85%;
  background-color: #afb8c133;
  border-radius: 6px;
  font-family: ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, "Liberation Mono", monospace;
}

.theme-github-light pre {
  margin-top: 0;
  margin-bottom: 16px;
  padding: 16px;
  overflow: auto;
  font-size: 85%;
  line-height: 1.45;
  background-color: #f6f8fa;
  border-radius: 6px;
}

.theme-github-light pre code {
  display: inline-block;
  padding: 0;
  margin: 0;
  overflow: visible;
  line-height: inherit;
  background-color: transparent;
  border: 0;
}

.theme-github-light table {
  border-spacing: 0;
  border-collapse: collapse;
  margin-top: 0;
  margin-bottom: 16px;
  width: 100%;
  overflow: auto;
}

.theme-github-light table th,
.theme-github-light table td {
  padding: 6px 13px;
  border: 1px solid #d1d9e0;
}

.theme-github-light table th {
  font-weight: 600;
  background-color: #f6f8fa;
}

.theme-github-light table tr {
  background-color: #ffffff;
  border-top: 1px solid #d1d9e0;
}

.theme-github-light table tr:nth-child(2n) {
  background-color: #f6f8fa;
}

.theme-github-light img {
  max-width: 100%;
  box-sizing: content-box;
}

.theme-github-light a {
  color: #0969da;
  text-decoration: none;
}

.theme-github-light a:hover {
  text-decoration: underline;
}

.theme-github-light hr {
  height: 0.25em;
  padding: 0;
  margin: 24px 0;
  background-color: #d1d9e0;
  border: 0;
}

.theme-github-light .task-list-item {
  list-style-type: none;
}

.theme-github-light .task-list-item input[type="checkbox"] {
  margin: 0 0.5em 0.25em -1.5em;
  vertical-align: middle;
}
`,$=`
/* GitHub Dark Theme */
.markdown-viewer.theme-github-dark {
  color: #e6edf3;
  background-color: #0d1117;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Noto Sans", Helvetica, Arial, sans-serif;
  font-size: 16px;
  line-height: 1.6;
  word-wrap: break-word;
}

.theme-github-dark h1,
.theme-github-dark h2 {
  border-bottom: 1px solid #30363d;
  padding-bottom: 0.3em;
}

.theme-github-dark h1 { font-size: 2em; margin-top: 24px; margin-bottom: 16px; font-weight: 600; }
.theme-github-dark h2 { font-size: 1.5em; margin-top: 24px; margin-bottom: 16px; font-weight: 600; }
.theme-github-dark h3 { font-size: 1.25em; margin-top: 24px; margin-bottom: 16px; font-weight: 600; }
.theme-github-dark h4 { font-size: 1em; margin-top: 24px; margin-bottom: 16px; font-weight: 600; }
.theme-github-dark h5 { font-size: 0.875em; margin-top: 24px; margin-bottom: 16px; font-weight: 600; }
.theme-github-dark h6 { font-size: 0.85em; margin-top: 24px; margin-bottom: 16px; font-weight: 600; color: #8d96a0; }

.theme-github-dark p { margin-top: 0; margin-bottom: 16px; }
.theme-github-dark blockquote {
  margin: 0 0 16px 0;
  padding: 0 1em;
  color: #8d96a0;
  border-left: 0.25em solid #30363d;
}

.theme-github-dark ul, .theme-github-dark ol {
  margin-top: 0;
  margin-bottom: 16px;
  padding-left: 2em;
}

.theme-github-dark li + li { margin-top: 0.25em; }

.theme-github-dark code {
  padding: 0.2em 0.4em;
  margin: 0;
  font-size: 85%;
  background-color: #6e768166;
  border-radius: 6px;
  font-family: ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, "Liberation Mono", monospace;
}

.theme-github-dark pre {
  margin-top: 0;
  margin-bottom: 16px;
  padding: 16px;
  overflow: auto;
  font-size: 85%;
  line-height: 1.45;
  background-color: #161b22;
  border-radius: 6px;
}

.theme-github-dark pre code {
  display: inline-block;
  padding: 0;
  margin: 0;
  overflow: visible;
  line-height: inherit;
  background-color: transparent;
  border: 0;
}

.theme-github-dark table {
  border-spacing: 0;
  border-collapse: collapse;
  margin-top: 0;
  margin-bottom: 16px;
  width: 100%;
  overflow: auto;
}

.theme-github-dark table th,
.theme-github-dark table td {
  padding: 6px 13px;
  border: 1px solid #30363d;
}

.theme-github-dark table th {
  font-weight: 600;
  background-color: #161b22;
}

.theme-github-dark table tr {
  background-color: #0d1117;
  border-top: 1px solid #30363d;
}

.theme-github-dark table tr:nth-child(2n) {
  background-color: #161b22;
}

.theme-github-dark img {
  max-width: 100%;
  box-sizing: content-box;
}

.theme-github-dark a {
  color: #4493f8;
  text-decoration: none;
}

.theme-github-dark a:hover {
  text-decoration: underline;
}

.theme-github-dark hr {
  height: 0.25em;
  padding: 0;
  margin: 24px 0;
  background-color: #30363d;
  border: 0;
}

.theme-github-dark .task-list-item {
  list-style-type: none;
}

.theme-github-dark .task-list-item input[type="checkbox"] {
  margin: 0 0.5em 0.25em -1.5em;
  vertical-align: middle;
}
`,b={"github-light":y,"github-dark":$};function O(e){return b[e]}function C(){return Object.values(b).join(`

`)}export{c as extractTOC,u as generateHeadingId,C as getAllThemes,O as getTheme,$ as githubDarkTheme,y as githubLightTheme,S as renderMarkdown,R as renderMarkdownSync,b as themes,p as wrapWithTheme};//# sourceMappingURL=index.mjs.map
//# sourceMappingURL=index.mjs.map